import Login from "../pages/auth/Signin";
import Signup from "../pages/auth/Signup";
import ConfirmPassword from "../pages/auth/ConfirmPassword";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import VerifyEmail from "../pages/auth/VerifyEmail";
import PhoneNumber from "../pages/auth/PhoneNumber";
import SyncWithSingpass from "../pages/auth/SyncWithSingpass";
import ConfirmEmail from "../pages/auth/ConfirmEmail";
import OTPCode from "../pages/auth/OtpCode";
import ContactUs from "../pages/auth/ContactUs";
import Dashboard from "../scenes/dashboard";
// import Team from "../scenes/team";
import Loan from "../scenes/loan";

// import Dashboardlayout from "../layout/Dashboardlayout";'
import DashboardLayout from "../../src/pages/dashboard/dashboard";
import DashboardBorrowerLayout from "../../src/pages/borrower-dashboard/borrower-dashboard";
import BorrowerLoan from "../../src/borrower/loan/loan";
import BorrowerApplyLoan from "../../src/borrower/loan/apply-loan";
import Messaging from "../../src/borrower/loan/message";
import AdminMessaging from "../../src/borrower/loan/message-admin";
import BorrowerOngoingLoans from "../../src/borrower/loan/ongoing-loans";
import BorrowerRequestedLoans from "../../src/borrower/loan/pending-loans";
import BorrowerAcceptedLoans from "../../src/borrower/loan/accepted-loan";
import BorrowerLoanHub from "../../src/borrower/loan/loan-hub";
import BorrowerAgreements from "../../src/borrower/agreements";
import BorrowerTransactions from "../../src/borrower/transactions";
import Layout from "../layout/VerticalLayout";
import LoanRequestGrid from "../scenes/loan-request-grid";
import LoanRequestList from "../scenes/loan-request-list";
import AcceptedLoans from "../scenes/accepted-loans";
import PendingAcceptance from "../scenes/pending-acceptance";
import DelayedPayments from "../scenes/delayed-payments";
import Analytics from "../scenes/analytics";
import Agreements from "../scenes/agreements";
import Subscription from "../scenes/subscription";
import Profile from "../scenes/profile";
import DashboardAdminLayout from "../pages/admin-dashboard/admin-dashboard";
import Users from "../admin/users";
import OngoingAgreement from "../admin/agreement/ongoing-agreement";
import GenerateAgreement from "../admin/agreement/generate-agreement";
import PendingSign from "../admin/agreement/pending-sign";
import LenderPayment from "../admin/payment/lender-payment";
import BorrowerPayment from "../admin/payment/borrower-payment";
import Advertisement from "../admin/advertisement";
import AdobeSign from "../scenes/AdobeSign";
import OfferedLoan from "../admin/loan/offered-loan";
import RequestedLoan from "../admin/loan/request-loan";
import OngoingLoan from "../admin/loan/ongoing-loan";
import AdminLoan from "../admin/loan/admin-loan";
import AdminAnalytic from "../admin/admin-analytics";
import UserJourneyAnalytics from "../admin/user-journey-analytics";
import DashboardMobile from "../borrower/borrower_mobile/dashboard_mobile";
import SidebarMobile from "../borrower/global/SidebarMobile";
import UserDatabase from "../admin/user-database";
import RedFlagged from "../admin/loan/red-flagged";
import ProfileStaging from "../borrower/profile staging";
import WhySmartlend from "../pages/smart-lend-frontend/src/WhySmartLend";
import FrequentlyAskedQuestion from "../pages/smart-lend-frontend/src/Faq";
import ContactUsLandingPage from "../pages/smart-lend-frontend/src/ContactUs";
import NewsEvents from "../pages/smart-lend-frontend/src/NewsEvents";
import PartnerWithUs from "../pages/smart-lend-frontend/src/PartnerWithUs";
import NewsAndEvents from "../admin/nande";
import DirectorAuthorization from "../pages/smart-lend-frontend/src/DirectorAuthorization";
import VerifyBorrower from "../admin/verify-borrower";
import Roadmap from "../pages/smart-lend-frontend/src/Roadmap";
import ViewFeedback from "../admin/view-feedback";
import CorporateStructureLoan from "../admin/loan/corporate-structure-loan";
import Valuer from "../admin/property-valuer";
import EmployeeSetup from "../admin/employee";
import MyProfile from "../pages/dashboard/myprofile";
import SuperAdmin from "../pages/smart-lend-frontend/src/SuperAdmin";
import DocumentBuilder from "../scenes/documentBuilder";
import RevampHomepage from "../pages/smart-lend-frontend/src/revamphomepage";
import TestingHomepage from "../pages/smart-lend-frontend/src/TestingHomepage";
import SolePropStruvtureLoan from "../admin/loan/sole-prop-loan";
import TestCharge from "../admin/loan/test-charge";
import ViewAdminTask from "../admin/admin-task";
import CBSPartner from "../pages/smart-lend-frontend/src/CBSPartner";
import CbsCampagin from "../pages/borrower-dashboard/CbsCampaign";
import SupportLogin from "../pages/support/SupportLogin";
import SupportDashboard from "../pages/support/SupportDashboard";
import DocumentVault from "../pages/borrower-dashboard/DocumentVault";
import ChatBotForStaff from "../admin/loan/ChatbotForStaff";
import PropertyTermLoan from "../pages/borrower-dashboard/PropertyTermLoan";
import PersonalLoans from "../pages/borrower-dashboard/PersonalLoans";
import LPropLoan from "../scenes/profile/lproploan";
import VaultTagging from "../admin/loan/VaultTagging";
import PrivacyPolicy from "../pages/smart-lend-frontend/src/PrivacyPolicy";
import TermCondition from "../pages/smart-lend-frontend/src/TermCondition";
import SomethingWrongSignUp from "../pages/smart-lend-frontend/src/SomethingWrongSignUp";
import AdminWhatsapp from "../borrower/loan/whatsapp-admin";
import AllLoans from "../admin/loan/all-loans";
import BauthConf from "../borrower/profile staging/bauthconf";
import PropLoanConfirmation from "../borrower/profile staging/proploanconfirmation";
import PropertyCoOwnerMyinfo from "../borrower/profile staging/PropertyCoOwnerMyinfo";
import PersonalLoanMarketplace from "../scenes/profile/personalLoans";
import TestingLandingPageTemplate from "../pages/smart-lend-frontend/src/TestingLandingPageTemplate";
import CorporateCampaign from "../pages/smart-lend-frontend/src/CorporateCampaign";
import NewHomepage from "../pages/smart-lend-frontend/src/NewHomepage";
import MoneyLenderCampaign from "../pages/smart-lend-frontend/src/MoneyLenderCampaign";
import PropertyCampaign from "../pages/smart-lend-frontend/src/PropertyCampaign";
import MlAnalysisLanding from "../pages/smart-lend-frontend/src/MlAnalysisLanding";
import PortalLogin from "../pages/bank-statement-portal/PortalLogin";
import PortalDashboard from "../pages/bank-statement-portal/PortalDashboard";
import LenderPortalDashboard from "../pages/bank-statement-portal/LenderPortalDashboard";
import PortalUsersAdmin from "../admin/portal-users";
import ManageCases from "../scenes/manage-cases";

// import mapStatetoProps from "../layout/VerticalLayout";
// import Products from "../pages/admin/Products";
// import AddProduct from "../pages/admin/AddProduct";
const authRoutes = [
  { path: "/auth/signin", component: Login },
  { path: "/auth/forgot-password", component: ForgotPassword },
  { path: "/auth/reset-password", component: ResetPassword },
];

const landingPageRoutes = [
  { path: "/something-went-wrong", component: SomethingWrongSignUp },
  { path: "/home", component: NewHomepage },
  { path: "/whysmartlend", component: WhySmartlend },
  { path: "/revamp-homepage", component: RevampHomepage },
  {
    path: "/landing-choco-up",
    component: TestingLandingPageTemplate,
  },
  { path: "/corporate-campaign", component: CorporateCampaign },
  { path: "/new-homepage", component: NewHomepage },
  { path: "/money-lender-campaign", component: MoneyLenderCampaign },
  { path: "/property-campaign", component: PropertyCampaign },
  { path: "/ml-analysis", component: MlAnalysisLanding },
  { path: "/testing-homepage", component: TestingHomepage },
  { path: "/frequentlyaskedquestions", component: FrequentlyAskedQuestion },
  { path: "/contactus", component: ContactUsLandingPage },
  { path: "/news-events/:slug", component: NewsEvents },
  { path: "/news-events", component: NewsEvents },
  { path: "/cbs-partnership", component: CBSPartner },
  { path: "/partner-with-us", component: PartnerWithUs },
  { path: "/director-authorization", component: DirectorAuthorization },
  { path: "/roadmap", component: Roadmap },
  { path: "/slrysuperadmin", component: SuperAdmin },
  { path: "/sales", component: ChatBotForStaff },
  { path: "/privacy-policy", component: PrivacyPolicy },
  { path: "/terms-and-conditions", component: TermCondition },
  { path: "/b-auth-conf", component: BauthConf },
  { path: "/proplconfirmation", component: PropLoanConfirmation },
  { path: "/property-co-owner-myinfo", component: PropertyCoOwnerMyinfo },
];

const verifyRoutes = [
  { path: "/auth/signup", component: Signup },
  { path: "/auth/verify-email", component: VerifyEmail },
  { path: "/auth/confirm-password", component: ConfirmPassword },
  { path: "/auth/phone-number", component: PhoneNumber },
  { path: "/auth/otp-code", component: OTPCode },
  // { path: "/auth/sync-with-singpass", component: SyncWithSingpass },
  { path: "/auth/confirm-email", component: ConfirmEmail },
  { path: "/auth/contact-us", component: ContactUs },
];

const dashboardRoutes = [
  { path: "/dashboard", component: DashboardLayout },
  { path: "/loan-request", component: LoanRequestList },
  { path: "/loan-request-grid", component: LoanRequestGrid },
  { path: "/loan", component: Loan },
  { path: "/accepted-loans", component: AcceptedLoans },
  { path: "/pending-acceptance", component: PendingAcceptance },
  { path: "/l-payments", component: DelayedPayments },
  { path: "/analytics", component: Analytics },
  { path: "/agreements", component: Agreements },
  { path: "/subscription", component: Subscription },
  { path: "/profile", component: Profile },
  { path: "/adobe-sign", component: AdobeSign },
  { path: "/l-messages", component: Messaging },
  { path: "/l-profile", component: MyProfile },
  { path: "/l-document-builder", component: DocumentBuilder },
  { path: "/l-prop-loan-request", component: LPropLoan },
  { path: "/l-manual-giro", component: TestCharge },
  { path: "/l-personal-loan-marketplace", component: PersonalLoanMarketplace },
  { path: "/l-manage-cases", component: ManageCases },
  { path: "/l-bank-statement-portal", component: LenderPortalDashboard },
];
const borrowerDashboardRoutes = [
  { path: "/b-dashboard", component: DashboardBorrowerLayout },
  { path: "/b-loan", component: BorrowerLoan },
  { path: "/b-loan-hub", component: BorrowerLoanHub },
  { path: "/b-apply-loan", component: BorrowerApplyLoan },
  { path: "/b-loan-in-progress", component: BorrowerOngoingLoans },
  { path: "/b-requested-loans", component: BorrowerRequestedLoans },
  { path: "/b-accepted-loans", component: BorrowerAcceptedLoans },
  { path: "/b-agreements", component: BorrowerAgreements },
  { path: "/b-transactions", component: BorrowerTransactions },
  { path: "/b-profile", component: ProfileStaging },
  { path: "/stg-b-profile", component: ProfileStaging },
  { path: "/b-messages", component: Messaging },
  { path: "/b-cbs-campaign", component: CbsCampagin },
  { path: "/b-instant-prop-term-loan", component: PropertyTermLoan },
  { path: "/b-personal-loans", component: PersonalLoans },
  { path: "/b-document-vault", component: DocumentVault },
  { path: "/dashboard-mobile", component: DashboardMobile },
  { path: "/sidebar-mobile", component: SidebarMobile },
];

const adminDashboardRoutes = [
  { path: "/a-users", component: Users },
  { path: "/a-ongoing-agreement", component: OngoingAgreement },
  { path: "/a-generate-agreement", component: GenerateAgreement },
  { path: "/a-pending-sign", component: PendingSign },
  { path: "/a-lender-payment", component: LenderPayment },
  { path: "/a-borrower-payment", component: BorrowerPayment },
  { path: "/a-advertisement", component: Advertisement },
  { path: "/a-offered-loan", component: OfferedLoan },
  { path: "/a-requested-loan", component: RequestedLoan },
  { path: "/a-corporate-structure-loan", component: CorporateStructureLoan },
  { path: "/a-sole-prop-loan", component: SolePropStruvtureLoan },
  { path: "/a-ongoing-loan", component: OngoingLoan },
  { path: "/a-loan", component: AdminLoan },
  { path: "/a-analytic", component: AdminAnalytic },
  { path: "/a-user-analytics", component: UserJourneyAnalytics },
  { path: "/a-user-database", component: UserDatabase },
  { path: "/a-red-flagged", component: RedFlagged },
  { path: "/a-news-events", component: NewsAndEvents },
  { path: "/a-verify-borrower", component: VerifyBorrower },
  { path: "/a-message", component: AdminMessaging },
  { path: "/a-whatsapp", component: AdminWhatsapp },
  { path: "/a-feedback", component: ViewFeedback },
  { path: "/a-vault-tagging", component: VaultTagging },
  { path: "/a-admin-task", component: ViewAdminTask },
  { path: "/a-propvalue", component: Valuer },
  { path: "/a-employee", component: EmployeeSetup },
  { path: "/a-portal-users", component: PortalUsersAdmin },
  { path: "/a-manual-giro", component: TestCharge },
  { path: "/a-all-loans", component: AllLoans },
];

const verticalRoutes = [{ path: "/vertical-dashboard", component: Layout }];

const supportRoutes = [
  { path: "/support-login", component: SupportLogin },
  { path: "/cs-dashboard", component: SupportDashboard },
];

const portalRoutes = [
  { path: "/bank-statement-portal/login", component: PortalLogin },
  { path: "/bank-statement-portal", component: PortalDashboard },
];

export {
  authRoutes,
  landingPageRoutes,
  verifyRoutes,
  dashboardRoutes,
  verticalRoutes,
  borrowerDashboardRoutes,
  adminDashboardRoutes,
  supportRoutes,
  portalRoutes,
};
